import '@/assets/nachiguro.scss'

import { mountComponent } from './mount-component'

import EarningsIndex from '@/pages/earnings/Index.vue'
import CampaignsShow from '@/pages/campaigns/Show.vue'
import CampaignsOrdersNew from '@/pages/campaigns/orders/New.vue'
import CampaignsOrdersShow from '@/pages/campaigns/orders/Show.vue'

mountComponent({
  EarningsIndex,
  CampaignsShow,
  CampaignsOrdersNew,
  CampaignsOrdersShow
})
